import { render, staticRenderFns } from "./RequestFormIncidentCoupAttempt.vue?vue&type=template&id=531ca89b&scoped=true&"
import script from "./RequestFormIncidentCoupAttempt.vue?vue&type=script&lang=js&"
export * from "./RequestFormIncidentCoupAttempt.vue?vue&type=script&lang=js&"
import style0 from "./RequestFormIncidentCoupAttempt.vue?vue&type=style&index=0&id=531ca89b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ca89b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531ca89b')) {
      api.createRecord('531ca89b', component.options)
    } else {
      api.reload('531ca89b', component.options)
    }
    module.hot.accept("./RequestFormIncidentCoupAttempt.vue?vue&type=template&id=531ca89b&scoped=true&", function () {
      api.rerender('531ca89b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/RequestFormIncidentCoupAttempt.vue"
export default component.exports